import { defaultDigitalData } from './defaultDigitalData';
import { LOCALES } from './locales';
import cloneDeep from 'lodash/cloneDeep';
import {
    SITE_SECTION,
    GLOBAL_INTERACTION,
    CALL_EMAIL,
    REFERRAL_EXIT,
    ONCLICK_LINK_NAME,
    REFERRAL_EXIT_ONCLICK_LINK_NAME,
    LOGIN_STATUS_FALSE,
    LOGIN_STATUS_TRUE,
    VEHICLE_DETAILS_BUTTON_REFERRED_TO,
    FORD_PRO_ACCOUNT_REFERRED_TO,
    VEHICLE_DETAILS_BUTTON_ONCLICKS,
    GLOBAL_DOWNLOAD,
    EXPORT_REPORT_BUTTON_ONCLICK,
    EXPORT_REPORT_BUTTON_ONCLICK_LINK_NAME,
} from './analyticsConstants';
import { CookiePreferencesType } from './analyticsDataTypes';

declare global {
    interface Window {
        _satellite?: any;
    }
}

export const getLocale = () => window.location.pathname.split('/')[1];

export function stringifyDigitalData(digitalData: any) {
    return `var digitaldata = ${JSON.stringify(digitalData)}`;
}

const getRadUiVersion = (screenWidth: number) => {
    if (screenWidth < 768) {
        return 'ui:rad:mobile';
    } else if (screenWidth < 992) {
        return 'ui:rad:tablet';
    } else if (screenWidth >= 992) {
        return 'ui:rad:pc';
    } else {
        return '';
    }
};

export const fireAnalyticsEvent = (digitaldata: any, directCallName: string) => {
    const screenWidth = window.innerWidth;
    digitaldata.page.radUIVersion = getRadUiVersion(screenWidth);
    getAnalyticsScript().innerHTML = stringifyDigitalData(digitaldata);
    if (directCallName === GLOBAL_INTERACTION) {
        const props = {
            onclickLinkName: digitaldata?.onclick?.onclickLinkName || '',
            onclick: digitaldata?.onclick?.onclick || '',
            tool: digitaldata?.page?.tool || '',
            toolDescriptor: digitaldata?.page?.toolDescriptor || '',
            modelYear: '',
            nameplate: '',
            bodyModelTrim: '',
            currentMake: '',
            error: '',
            financeMasterCustomerNumber: '',
            financeNumberOfVehicles: '',
        };

        if (window._satellite) window._satellite.track(directCallName, props);
    } else {
        if (window._satellite) window._satellite.track(directCallName);
    }
};

export function getAnalyticsScript() {
    let analyticsScript = document.head.querySelector('#digitaldata');
    if (analyticsScript) {
        analyticsScript.remove();
    }
    analyticsScript = document.createElement('script');
    analyticsScript.setAttribute('id', 'digitaldata');
    analyticsScript.setAttribute('type', 'text/javascript');
    document.head.appendChild(analyticsScript);

    return analyticsScript;
}

export const constructDigitalData = (eventName: string, pageName: string, directCallName: string, tool: string, toolDescriptor: string, onClick: string, loginStatus: boolean, cookiePreferences: CookiePreferencesType) => {
    const locale = getLocale();

    const digitalDataObject = {
        digitalData: cloneDeep(defaultDigitalData),
        directCallName: directCallName,
    };

    if (loginStatus) {
        digitalDataObject.digitalData.user.loginStatus = LOGIN_STATUS_TRUE;
    } else {
        digitalDataObject.digitalData.user.loginStatus = LOGIN_STATUS_FALSE;
    }

    const CurrentLocale = LOCALES[locale as keyof typeof LOCALES] || LOCALES['default'];
    digitalDataObject.digitalData.page.userLanguage = CurrentLocale.language;
    digitalDataObject.digitalData.page.site = CurrentLocale.site;
    digitalDataObject.digitalData.page.client = CurrentLocale.client;
    digitalDataObject.digitalData.page.country = CurrentLocale.country;
    digitalDataObject.digitalData.page.siteSection = SITE_SECTION;
    digitalDataObject.digitalData.page.hierarchy = pageName;
    digitalDataObject.digitalData.event.action = eventName;
    digitalDataObject.digitalData.page.pageName = pageName;
    digitalDataObject.digitalData.page.tool = tool;
    digitalDataObject.digitalData.page.toolDescriptor = toolDescriptor;
    digitalDataObject.digitalData.onclick.onclick = onClick;
    digitalDataObject.digitalData.onclick.onclickLinkName = ONCLICK_LINK_NAME;
    digitalDataObject.digitalData.page.pageNameNoVehicle = pageName;

    if (directCallName == CALL_EMAIL) {
        digitalDataObject.digitalData.user.leadType = 'click-to';
        digitalDataObject.digitalData.user.leadOptIn = 'click to email';
    }

    if (directCallName == REFERRAL_EXIT) {
        digitalDataObject.digitalData.onclick.onclickLinkName = REFERRAL_EXIT_ONCLICK_LINK_NAME;
        if (digitalDataObject.digitalData.onclick.onclick === VEHICLE_DETAILS_BUTTON_ONCLICKS) {
            digitalDataObject.digitalData.onclick.referredTo = VEHICLE_DETAILS_BUTTON_REFERRED_TO;
        } else {
            digitalDataObject.digitalData.onclick.referredTo = FORD_PRO_ACCOUNT_REFERRED_TO;
        }
    }

    if (directCallName == GLOBAL_DOWNLOAD) {
        digitalDataObject.digitalData.onclick.onclickLinkName = EXPORT_REPORT_BUTTON_ONCLICK_LINK_NAME;
        digitalDataObject.digitalData.onclick.onclick = EXPORT_REPORT_BUTTON_ONCLICK;
    }

    if (cookiePreferences) {
        digitalDataObject.digitalData.user.optInStatus = getCookiePreferences(cookiePreferences);
    }

    return digitalDataObject;
};

export const getCookiePreferences = (cookiePreferences: CookiePreferencesType) => {
    const settingsArr = [];
    const cookieArr = Object.entries(cookiePreferences);
    for (const cookie of cookieArr) {
        settingsArr.push(cookie.join(':'));
    }
    return settingsArr.join('|').replaceAll('_', ' ').replaceAll('true', 'yes').replaceAll('false', 'no');
};
